export const USEFUL_LINKS = {
  ar: [
    { 
      name: 'هيئة الدواء المصرية', 
      url: 'https://www.eda.gov.eg/' 
    },
    { 
      name: 'وزارة الصحة والسكان', 
      url: 'https://www.mohp.gov.eg/' 
    },
    { 
      name: 'منظمة الصحة العالمية', 
      url: 'https://www.who.int/ar' 
    },
    { 
      name: 'هيئة الاستثمار المصرية', 
      url: 'https://www.investinegypt.gov.eg/' 
    },
  ],
  en: [
    { 
      name: 'Egyptian Drug Authority', 
      url: 'https://www.eda.gov.eg/' 
    },
    { 
      name: 'Ministry of Health', 
      url: 'https://www.mohp.gov.eg/' 
    },
    { 
      name: 'World Health Organization', 
      url: 'https://www.who.int/' 
    },
    { 
      name: 'General Authority for Investment', 
      url: 'https://www.investinegypt.gov.eg/' 
    },
  ],
};
